import type { CustomerJobMetadataPolicy } from '~/lib/customer-job-metadata';
import { MlmPhotosType } from '~/tenants/mlm/performable/photos/MlmPhotosConfig';

/**
 * MLM: which fields of each service a customer's post may set (lib/customer-
 * job-metadata.ts), by service id. Every field of every service's schema is
 * listed once, customer or office (customer-job-metadata.test.ts).
 */
export const MLM_CUSTOMER_JOB_METADATA: Record<string, CustomerJobMetadataPolicy> = {
  // MlmPhotosForm: the customer's photos are Standard; the count shot and the hours of a Commercial
  // order (office-only) are not the customer's; no form sets `photos`.
  photos: {
    customer: [
      'type',
      'extra_photos_max',
      'instructions',
      'detail',
      'detail_notes',
      'community',
      'community_notes',
      'twilight_type',
      'twilight_photos',
    ],
    office: ['extra_photos_actual', 'hours', 'photos'],
    officeValues: { type: Object.values(MlmPhotosType).filter((type) => type !== MlmPhotosType.STANDARD) },
  },
  aerial: { customer: ['type'], office: [] },
  '3d': { customer: [], office: [] },
  floorplan: { customer: [], office: [] },
  staging: { customer: ['photos'], office: [] },
  // no form sets the delivery address.
  flyer: { customer: ['quantity', 'shipping'], office: ['delivery'] },
  // no form sets the delivery address.
  brochures: { customer: ['option', 'quantity', 'shipping'], office: ['delivery'] },
  // MlmHeadshotForm shows neither.
  headshot: { customer: ['people', 'type', 'parking'], office: ['group', 'notes'] },
  virtual: { customer: ['photos'], office: [] },
  walkthrough: { customer: ['agent'], office: [] },
};
